import ProfileView from './Profile.view';
export * from './Profile.view';

export const Profile = (props) => ProfileView(props);

export default Profile;

